// TalkRobin plans, kept in sync with the marketing site (marketing/src/config/plans.ts).
// Server-side limits live in config/talkrobin_plans.yml.
export const DEFAULT_PLAN = 'free';
export const BILLING_PERIODS = ['monthly', 'yearly'];
export const TRIAL_DAYS = 14;

export const PLANS = {
  free: {
    name: 'Free',
    price: { monthly: 0, yearly: 0 },
    highlights: [
      '1 website, 1 agent',
      '100 chats a month',
      'Live Monitoring + visitor alerts',
    ],
  },
  pro: {
    name: 'Pro',
    price: { monthly: 19, yearly: 15 },
    trial: true,
    highlights: [
      '3 websites, 3 agents, unlimited chats',
      '500 session replays a month',
      'Full visitor activity & smart alerts',
    ],
  },
  business: {
    name: 'Business',
    price: { monthly: 49, yearly: 39 },
    trial: true,
    highlights: [
      '10 websites, 7 agents, unlimited chats',
      '1,000 session replays a month',
      'Remove TalkRobin branding',
    ],
  },
};

export const planFromQuery = value => (PLANS[value] ? value : DEFAULT_PLAN);
export const billingFromQuery = value =>
  BILLING_PERIODS.includes(value) ? value : BILLING_PERIODS[0];
